// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BookmarkController from "./bookmark_controller"
import ChairArrangementController from "./chair_arrangement_controller"
import HelloController from "./hello_controller"
application.register("bookmark", BookmarkController)
application.register("chair-arrangement", ChairArrangementController)
application.register("hello", HelloController)
